<template>
    <TermsBox>
        <v-container grid-list-xs>
            <v-sheet class="pa-5" elevation="3">
                <v-row class="py-0">
                    <v-col class="py-0">
                        <div class="tc-container">
                            <ResponsiveImage :image-url="url" class="terms-img text-center" width="100%" />
                        </div>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-container>
    </TermsBox>
</template>

<script>
    import TermsBox from "@/components/terms/TermsBox.vue"
    import BackButton from "@/components/button/BackButton.vue"

    import { appendWebSessionId } from "@/util/url"
    import { sessionState } from "@/state"

    export default {
        components: { BackButton, TermsBox },

        data() {
            return {
                url: appendWebSessionId(`/api/v1/providers/${sessionState.providerKey}/documents/agreement`),
            }
        },
    }
</script>

<style lang="scss" scoped>
    .tc-container {
        height: 60vh;
        overflow-y: scroll;
    }
</style>
